module.exports = __webpack_public_path__ + "static/CRS_06_new-9db3c628c828f1b7299a0a2b9c3cbd72.svg";